import { ProviderModel } from "./ProviderModel";

export class ScartiConsuntivoVolumiModel {
  id: number;
  numAnnoMese: number;
  regionCod: string;
  localCustomerCod: string;
  contractCod: string;
  resourcesUnitCod: string;
  designCod: string;
  shareName: string;
  providerCod: string;
  applicationDescription: string;
  errors: string;
  layerCod: string;
  l1Cod: string;
  l2Cod: string;
  l3Cod: string;
  subsidary: string;
  serialNumber: string;
  slaType: string;
  ssru: string;
  vol: string;
  numAnnoMeseRif: number;
  numAnnoMeseBilled: number;
  unit: string;
  designServicesCod: string;
  applicationCod: string;
  serviceVariantCod: string;
  serviceVariantName: string;
  sizeCod: string;
  siteCod: string;
  numAnnoMeseAcceptance: number;
  ulbStatus: string;
  requestId: number;
  requestDesc: string;
  instanceName: string;
  systemName: string;
  monthlyForecastQuantity: number;
  approverRequestor: string;
  notes: string;
  isRecovery: boolean;
  provider: ProviderModel;

  constructor(id?: number,
              numAnnoMese?: number,
              regionCod?: string,
              localCustomerCod?: string,
              contractCod?: string,
              resourcesUnitCod?: string,
              designCod?: string,
              shareName?: string,
              providerCod?: string,
              applicationDescription?: string,
              errors?: string,
              layerCod?: string,
              l1Cod?: string,
              l2Cod?: string,
              l3Cod?: string,
              subsidary?: string,
              serialNumber?: string,
              slaType?: string,
              ssru?: string,
              vol?: string,
              numAnnoMeseRif?: number,
              unit?: string,
              designServicesCod?: string,
              applicationCod?: string,
              serviceVariantCod?: string,
              serviceVariantName?: string,
              sizeCod?: string,
              siteCod?: string,
              numAnnoMeseAcceptance?: number,
              ulbStatus?: string,
              requestId?: number,
              requestDesc?: string,
              instanceName?: string,
              systemName?: string,
              monthlyForecastQuantity?: number,
              approverRequestor?: string,
              notes?: string) {
    this.id = id;
    this.numAnnoMese = numAnnoMese;
    this.regionCod = regionCod;
    this.localCustomerCod = localCustomerCod;
    this.contractCod = contractCod;
    this.resourcesUnitCod = resourcesUnitCod;
    this.designCod = designCod;
    this.shareName = shareName;
    this.providerCod = providerCod;
    this.applicationDescription = applicationDescription;
    this.errors = errors;
    this.layerCod = layerCod;
    this.l1Cod = l1Cod;
    this.l2Cod = l2Cod;
    this.l3Cod = l3Cod;
    this.subsidary = subsidary;
    this.serialNumber = serialNumber;
    this.slaType = slaType;
    this.ssru = ssru;
    this.vol = vol;
    this.numAnnoMeseRif = numAnnoMeseRif;
    this.unit = unit;
    this.designServicesCod = designServicesCod;
    this.applicationCod = applicationCod;
    this.serviceVariantCod = serviceVariantCod;
    this.serviceVariantName = serviceVariantName;
    this.sizeCod = sizeCod;
    this.siteCod = siteCod;
    this.numAnnoMeseAcceptance = numAnnoMeseAcceptance;
    this.ulbStatus = ulbStatus;
    this.requestId = requestId;
    this.requestDesc = requestDesc;
    this.instanceName = instanceName;
    this.systemName = systemName;
    this.monthlyForecastQuantity = monthlyForecastQuantity;
    this.approverRequestor = approverRequestor;
    this.notes = notes;
  }
}

export class ScartiConsuntivoVolumiReportModel extends  ScartiConsuntivoVolumiModel {
  numAnnoMeseFrom: number;
  numAnnoMeseTo: number;
}
